import { Model } from "pinia-orm";
import { Domain } from "@/models";

export default class DomainGroup extends Model {
  static entity = "domainGroups";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      name: this.string(""),
      code: this.string(""),
      domainGroupCodeLabel: this.string(""),
      domains: this.hasMany(Domain, "domainGroupUuid"),
    };
  }
}
